export class JsonService {
  toJson = (obj, pretty) => {
    const buf = [];
    this.toJsonArray(buf, obj, pretty ? '\n  ' : null, []);
    return buf.join('');
  };

  toJsonArray = (buf, obj, pretty, stack) => {
    if (angular.isObject(obj)) {
      if (obj === window) {
        buf.push('WINDOW');
        return;
      }

      if (obj === document) {
        buf.push('DOCUMENT');
        return;
      }

      stack.push(obj);
    }
    if (obj === null) {
      buf.push('null');
    } else if (obj instanceof RegExp) {
      buf.push(this.quoteUnicode(obj.toString()));
    } else if (angular.isFunction(obj)) {
      return;
    } else if (typeof obj === 'boolean') {
      buf.push(String(obj));
    } else if (angular.isNumber(obj)) {
      if (isNaN(obj)) {
        buf.push('null');
      } else {
        buf.push(String(obj));
      }
    } else if (angular.isString(obj)) {
      return buf.push(this.quoteUnicode(obj));
    } else if (angular.isObject(obj)) {
      if (angular.isArray(obj)) {
        buf.push('[');
        const len = obj.length;
        let sep = false;
        for (let i = 0; i < len; i++) {
          const item = obj[i];
          if (sep) {
            buf.push(',');
          }
          if (
            !(item instanceof RegExp) &&
            (angular.isFunction(item) || angular.isUndefined(item))
          ) {
            buf.push('null');
          } else {
            this.toJsonArray(buf, item, pretty, stack);
          }
          sep = true;
        }
        buf.push(']');
      } else if (angular.isElement(obj)) {
        buf.push('DOM_ELEMENT');
      } else if (angular.isDate(obj)) {
        buf.push(this.quoteUnicode(this.jsonDateToString(obj)));
      } else {
        buf.push('{');
        if (pretty) {
          buf.push(pretty);
        }
        let comma = false;
        const childPretty = pretty ? pretty + '  ' : false;
        const keys = [];
        for (const k in obj) {
          if (
            k != 'this' &&
            k != '$parent' &&
            k.substring(0, 2) != '$$' &&
            obj.hasOwnProperty(k) &&
            obj[k] !== undefined
          ) {
            keys.push(k);
          }
        }
        keys.sort();
        for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
          const key = keys[keyIndex];
          const value = obj[key];
          if (!angular.isFunction(value)) {
            if (comma) {
              buf.push(',');
              if (pretty) {
                buf.push(pretty);
              }
            }
            buf.push(this.quoteUnicode(key));
            buf.push(':');
            this.toJsonArray(buf, value, childPretty, stack);
            comma = true;
          }
        }
        buf.push('}');
      }
    }
    if (angular.isObject(obj)) {
      stack.pop();
    }
  };

  quoteUnicode = (string) => {
    const chars = ['"'];
    for (let i = 0; i < string.length; i++) {
      const code = string.charCodeAt(i);
      let ch = string.charAt(i);
      switch (ch) {
        case '"':
          chars.push('\\"');
          break;
        case '\\':
          chars.push('\\\\');
          break;
        case '\n':
          chars.push('\\n');
          break;
        case '\f':
          chars.push('\\f');
          break;
        case '\r':
          chars.push((ch = '\\r'));
          break;
        case '\t':
          chars.push((ch = '\\t'));
          break;
        default:
          if (32 <= code && code <= 126) {
            chars.push(ch);
          } else {
            const encode = '000' + code.toString(16);
            chars.push('\\u' + encode.substring(encode.length - 4));
          }
      }
    }
    chars.push('"');
    return chars.join('');
  };

  jsonDateToString = (date) => {
    if (!date) {
      return date;
    }
    const isoString = date.toISOString ? date.toISOString() : '';
    return isoString.length == 24
      ? isoString
      : // @ts-ignore
        this.padNumber(date.getUTCFullYear(), 4) +
          '-' +
          // @ts-ignore
          this.padNumber(date.getUTCMonth() + 1, 2) +
          '-' +
          // @ts-ignore
          this.padNumber(date.getUTCDate(), 2) +
          'T' +
          // @ts-ignore
          this.padNumber(date.getUTCHours(), 2) +
          ':' +
          // @ts-ignore
          this.padNumber(date.getUTCMinutes(), 2) +
          ':' +
          // @ts-ignore
          this.padNumber(date.getUTCSeconds(), 2) +
          '.' +
          // @ts-ignore
          this.padNumber(date.getUTCMilliseconds(), 3) +
          'Z';
  };

  padNumber = (num, digits, trim) => {
    let neg = '';
    if (num < 0) {
      neg = '-';
      num = -num;
    }
    num = String(num);
    while (num.length < digits) {
      num = '0' + num;
    }
    if (trim) {
      num = num.substr(num.length - digits);
    }
    return neg + num;
  };
}

/*
 * This service is primarily used for handleData to remove Angular properties
 * from datacalls. Will not be neccessary in later versions of AngularJS
 */
angular.module('v6CoreModule').factory('jsonService', () => {
  return new JsonService();
});
